let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kH7y9")).then(() => parcelRequire('75eaP'));